function a({
  id: t,
  pages: o,
  lang: r
}) {
  if (!t) return null;
  const e = o.find((u) => {
    var n;
    return ((n = u.id) == null ? void 0 : n.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
  });
  return e ? e.urlPath[r] : null;
}
export {
  a as getRoutePathById
};
